<div class="container">
  <div class="highlight">
    <div class="highlight-desc">
      <h2>
        <span [innerHTML]="data.product_title"></span>
      </h2>
      <p [innerHTML]="data.product_description"></p>
    </div>
    <div class="highlight-img">
      <img loading="lazy" [src]="data.product_image.url">
    </div>
    <div class="button">
      <div>
        <a [routerLink]="data.product_cta_link" class="white ga-click" [attr.data-ga-reference]="removeLangFromRoute(data.product_cta_link)">{{ data.product_cta_label }} </a>
      </div>
      <div>
        <a [href]="data.product_link" class="blue ga-click" target="_blank" [attr.data-ga-reference]="removeLangFromRoute(data.product_link)">{{ data.product_label }}</a>
      </div>
    </div>
  </div>
</div>